<template>
    <div>
        <v-card class="mx-auto" 
            elevation="0"
        >
            <v-card-text  class="py-1">
                <v-icon>mdi-information-outline</v-icon>&nbsp;Configuration Last Updated: {{ lastupdated }} <br/>
            </v-card-text>
            <v-card-subtitle class="py-0 ma-0">
                <v-switch
                    v-model="editmode"
                    inset
                    color="#8FABB3"
                >
                    <template v-slot:label>
                        Edit Mode: {{getEditModeLabel}}
                        <v-progress-circular
                            color="#8FABB3"
                            indeterminate
                            class="ml-2"
                            v-if="settingupdate"
                        ></v-progress-circular>
                    </template>
                </v-switch>
            </v-card-subtitle>
            <v-divider></v-divider>
            <v-card-text>
                <table id="table">
                    <tr>
                        <td><strong :style="`color: ${getTextColor}`">Statement access enabled</strong></td>
                        <td>
                            <v-switch
                                v-model="statementAccess"
                                :disabled="!editmode"
                                true-value="Yes"
                                false-value="No"
                                :label="statementAccess"
                                @change="updateConfiguration()"
                            ></v-switch>
                        </td>
                    </tr>
                    <tr>
                        <td><strong :style="`color: ${getTextColor}`">T4A access enabled</strong></td>
                        <td>
                            <v-switch
                                v-model="T4AAccess"
                                :disabled="!editmode"
                                true-value="Yes"
                                false-value="No"
                                :label="T4AAccess"
                                @change="updateConfiguration()"
                            ></v-switch>
                        </td>
                    </tr>
                    <tr>
                        <td><strong :style="`color: ${getTextColor}`">T2202A access enabled</strong></td>
                        <td>
                            <v-switch
                                v-model="T2202AAccess"
                                :disabled="!editmode"
                                true-value="Yes"
                                false-value="No"
                                :label="T2202AAccess"
                                @change="updateConfiguration()"
                            ></v-switch>
                        </td>
                    </tr>
                    <!--
                    <tr>
                        <td><strong :style="`color: ${getTextColor}`">Net Tuition Summary access enabled</strong></td>
                        <td>
                            <v-switch
                                v-model="netTuitionSummaryAccess"
                                :disabled="!editmode"
                                true-value="Yes"
                                false-value="No"
                                :label="netTuitionSummaryAccess"
                                @change="updateConfiguration()"
                            ></v-switch>
                        </td>
                    </tr>
                    -->
                    <tr>
                        <td><strong :style="`color: ${getTextColor}`">Net Bill access enabled</strong></td>
                        <td>
                            <v-switch
                                v-model="netBillAccess"
                                :disabled="!editmode"
                                true-value="Yes"
                                false-value="No"
                                :label="netBillAccess"
                                @change="updateConfiguration()"
                            ></v-switch>
                        </td>
                    </tr>
                </table>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
export default {
    props: {
        statementAccess: {
            required: true
        },
        T4AAccess: {
            required: true
        },
        T2202AAccess: {
            required: true
        },
        netTuitionSummaryAccess: {
            required: true
        },
        netBillAccess: {
            required: true
        },
        lastupdated: {
            required: true
        },
    },
    data() {
        return {
            host: location.hostname.toString(),
            editmode: false,
            settingupdate: false,
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500
        }
    },
    computed: {
        getEditModeLabel(){
            const that = this;

            if(that.editmode == true){
                return "On"
            }else {
                return "Off"
            }
        },
        getTextColor(){
            const that = this;
            if(that.editmode == true){
                return "#000000"
            }else {
                return "#757575"
            }
        }
    },
    methods: {
        updateConfiguration(){
            const that = this;
            that.settingupdate = true;
            let api = 'https://'+that.host+'/cgi-bin/sfs-portal-api/api.py';

            const formData = new FormData();

            formData.append("mode", "adminConfigSet");
            formData.append("data", JSON.stringify({
                statement : that.statementAccess,
                t4a: that.T4AAccess,
                t2202a: that.T2202AAccess,
                nettuitionsummary: that.netTuitionSummaryAccess,
                netbill: that.netBillAccess
            }));

            //API calling
            fetch(api,{
                method: "POST",
                body: formData
            })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#FFCC80"); //orange
                    }

                    that.settingupdate = false;
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.settingupdate = false;
                })
            //End of API calling
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    }
}
</script>
<style scoped>
#table {
    border-collapse: collapse;
    width: 70%;
}
#table tr {
    height: 20px;
}
#table tr:nth-child(odd) {
    background-color: #C5D7DC;
}
#table td {
    padding: 10px;
}
</style>